import { Grid, Typography } from '@material-ui/core';
import { useStyles } from "./CTAComponentStyles";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Button from '../../components/button';
import { useHistory } from 'react-router-dom';
// import advertisement from '../../assets/advertisment.jpg';
import { useEffect } from 'react';

function CTAAdvertisementComponent() {
    const classes = useStyles();
    const history = useHistory();
    useEffect(() => {
        (window as any).googletag = (window as any)?.googletag || { cmd: [] };
        (window as any).googletag.cmd.push(function () {
            (window as any).googletag
                .defineSlot(
                    '/6355419/Travel/Europe', ['fluid'], 'banner-ad')
                .addService((window as any).googletag.pubads());
                (window as any).googletag.enableServices();
        });
        ((window as any).googletag).cmd.push(function () {
            ((window as any).googletag).display('banner-ad');
        });
    }, [])
    return (
        <Grid container item xs={10} className={classes.ctaSectionWrapper}>
            <Grid item xs={12} sm={8} className={classes.loginCTABG}>
                <Grid item xs={12} className={classes.loginCTA}>
                    <Typography component="h1" variant="h5" color="inherit" className={classes.ctaSectionHeader}>
                        The Simplicity of medical imaging, everywhere
                    </Typography>
                    <Typography variant="body2" color="inherit" className={classes.ctaSectionText} paragraph>
                        We are here to provide  immediate sharing, access and mobility of medical images and reports.
                        Replace printing, CD Burning, faxing, and shipping of medical data by sharing straight to any
                        smartphone, computer, or tablet
                    </Typography>
                    <Grid className={classes.ctaButtonsWrapper}>
                        <Button
                            text={'Clinician Signup'}
                            version={'secondary'}
                            icon={<ArrowForwardIcon />}
                            action={() => {
                                history.push('/signup')
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={4} className={classes.advertisement}>
                {/* <img src={advertisement} alt='Advertisement'/> */}
                <div id="banner-ad" style={{ width: '300px', height: '600px' }}>
                </div>
            </Grid>
        </Grid>
    )
}

export default CTAAdvertisementComponent
